import libertyHomeGuardLogo from '../images/partners/liberty-home-guard.png';

export type Partner = {
  code: string;
  name: string;
  logo: string;
};

const partners: Partner[] = [
  {
    code: 'libertyhomeguard',
    name: 'Liberty Home Guard',
    logo: libertyHomeGuardLogo
  }
];

export const getPartnerByCode = (
  code: string | null | undefined
): Partner | null => {
  if (!code) return null;
  const normalized = code.trim().toLowerCase();
  return partners.find((p) => p.code === normalized) ?? null;
};
